import type { CompetitiveSource } from '@/app/competitive/useCompetitiveChannelConfig';

import { COMPETITOR_PLATFORM_OPTIONS } from '@/app/settings/constants';

export const ADD_COMPETITOR_INFO_MESSAGE =
  'Double-check each handle before adding. It may take up to 24 hours to validate and load competitor data due to API limitations.';

export const ADD_COMPETITOR_PANEL_CONTENT_CLASS = 'min-w-88';

export const ADD_COMPETITOR_DATA_LOADING_MESSAGE =
  "We're pulling in data for these accounts. This can take up to 24 hours — feel free to keep working while we finish up.";

export const ADD_COMPETITOR_DATA_LOADING_MESSAGE_SINGULAR =
  "We're pulling in data for this account. This can take up to 24 hours — feel free to keep working while we finish up.";

export const SEPARATOR_HINT = 'Separate multiple handles with a comma, spacebar, or enter';

export const DUPLICATE_HANDLE_ERROR = 'Remove handles that have already been added';

export const ALREADY_ADDED_TOOLTIP = 'Already added as a competitor';

export const MIN_SEARCH_LENGTH = 2;

export const NO_RESULTS_TEXT = 'No options found';

export const SEARCH_ERROR_TEXT = 'Something went wrong, please try again.';

export interface AddCompetitorCopy {
  notFoundError: string;
  lookupError: string;
  successSingular: (name: string) => string;
  successPlural: (count: number) => string;
  limitReachedError: string;
  requestError: string;
  refreshError: string;
}

export function buildAddCompetitorCopy(source: CompetitiveSource): AddCompetitorCopy {
  const { title } = COMPETITOR_PLATFORM_OPTIONS[source];
  return {
    notFoundError: `Handle not found on ${title}. Check the spelling and try again.`,
    lookupError: `Cannot check this ${title} handle. Remove it and enter it again.`,
    successSingular: () => ADD_COMPETITOR_DATA_LOADING_MESSAGE_SINGULAR,
    successPlural: () => ADD_COMPETITOR_DATA_LOADING_MESSAGE,
    limitReachedError: COMPETITOR_PLATFORM_OPTIONS[source].limitReachedMessage,
    requestError: `Something went wrong adding your ${title} competitor. Please try again later.`,
    refreshError:
      "Competitors were added, but the page couldn't refresh. Refresh the page to see the latest data.",
  };
}
